import React from 'react';  
import './index.css';
import {
    connect
} from 'react-redux';
import {
    actionCreators
} from 'courseLiveStore';
import {Tabs, WingBlank, WhiteSpace } from 'antd-mobile';
import TabIntro from '../tabIntro';
import TabAttachment from '../tabAttachment'
import TabTopic from '../tabTopic'
import { StickyContainer, Sticky } from 'react-sticky';
function renderTabBar(props) {
  return (<Sticky>
    {({ style }) => <div style={{ ...style, zIndex: 20,top:'45px' }}><Tabs.DefaultTabBar {...props} /></div>}
  </Sticky>);
}

const tabs = [
              { title: '课程介绍' },
              // { title: '附件' },
              // { title: '话题讨论' },
            ];
class InfoTab extends React.Component{ 
 
  topicClick(e,id){
    const {changeTopicId} =this.props
    this.props.topicClick(e)
    changeTopicId(id)
  }
 
  render(){ 
    const {info,attachmentList,topicChatList} = this.props;
    return (
      <div className="info-tab">
        <StickyContainer>
          <Tabs tabs={tabs}
            swipeable={false}
            initalPage={'t2'}
            renderTabBar={renderTabBar}>
            <div className="tab-main">
              <WingBlank>
                <TabIntro info={info}/>
              </WingBlank>
            </div>
            {/*<div className="tab-main">*/}
              {/*<WingBlank>*/}
                {/*<TabAttachment attachmentList={attachmentList}/>*/}
              {/*</WingBlank>*/}
            {/*</div>*/}
            {/*<div className="tab-main">*/}
            {/*  <WingBlank>*/}
            {/*    <TabTopic */}
            {/*      list={topicChatList} */}
            {/*      topicClick={(e,topic_id)=>{this.topicClick(e,topic_id)}} />*/}
            {/*  </WingBlank>*/}
            {/*</div>*/}
          </Tabs>
        </StickyContainer>
      </div>
      )
  }
}
 

const mapState = (state) => ({
  info: state.getIn(['courselive', 'info']),
  topicChatList: state.getIn(['courselive', 'topicChatList']),
  attachmentList: state.getIn(['courseproject', 'attachmentList']),
})

const mapDispatch = (dispatch) => ({
  changeTopicId(id){
     dispatch(actionCreators.changeTopicId(id))
  }  
})

export default connect(mapState, mapDispatch)(InfoTab);
